"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var VisibiltyHidden32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M25.12 6.646a.5.5 0 010 .708L7.354 25.12a.5.5 0 01-.708-.708l2.905-2.903c-.974-.843-1.907-1.89-3.045-3.354-.378-.486-.556-.722-1.406-1.855a.5.5 0 010-.6c.85-1.133 1.028-1.37 1.406-1.855C9.697 9.74 12.172 8 16 8c2.041 0 3.787.563 5.392 1.666l3.02-3.02a.5.5 0 01.708 0zm-1.318 5.164a31.927 31.927 0 011.76 2.117c.243.314.425.552.74.973l.207.277.392.524a.5.5 0 01-.001.599c-.85 1.133-1.028 1.37-1.406 1.855C22.303 22.26 19.828 24 16 24c-1.25 0-2.394-.213-3.459-.632a.5.5 0 01.366-.93c.947.372 1.966.562 3.093.562 3.446 0 5.684-1.573 8.705-5.459.265-.34.43-.558.808-1.06l.229-.304.134-.178a97.51 97.51 0 00-1.104-1.46 30.983 30.983 0 00-1.706-2.052.5.5 0 01.736-.677zM16 9c-3.446 0-5.684 1.573-8.705 5.459-.337.433-.514.667-1.17 1.541.656.874.833 1.108 1.17 1.541C8.418 18.986 9.325 20 10.26 20.8l2.122-2.124a4.5 4.5 0 016.294-6.294l1.996-1.995C19.274 9.464 17.769 9 16 9zm-.001 3.5a3.5 3.5 0 00-2.9 5.459l4.86-4.86a3.483 3.483 0 00-1.96-.599z", className: "visibilty-hidden-32_svg__path-1" }))); };
var StyledVisibiltyHidden32 = styled_components_1.default(VisibiltyHidden32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledVisibiltyHidden32;
var templateObject_1;
//# sourceMappingURL=VisibiltyHidden32.js.map